'use es6';

import { Record } from 'immutable';
import Raven from 'raven-js';
const SUBCATEGORY_TO_SOURCE = {
  site_page: 'WEBPAGE',
  landing_page: 'LANDING_PAGE',
  normal_blog_post: 'BLOG_POST'
};
const AdCreationWebsiteUrlRecord = Record({
  websiteUrl: '',
  landingPage: null,
  preselected: false,

  getRequestData() {
    if (this.landingPage) {
      const sourceType = SUBCATEGORY_TO_SOURCE[this.landingPage.get('subcategory')];

      if (!sourceType) {
        Raven.captureMessage('Missing source conversion for hubspot page', {
          extra: Object.assign({}, this.landingPage.toJS())
        });
        return {
          landingPageUrl: this.landingPage.get('url')
        };
      }

      return {
        landingPageUrl: this.landingPage.get('url'),
        sourceType,
        sourceId: this.landingPage.get('value').toString()
      };
    }

    return {
      landingPageUrl: this.websiteUrl
    };
  }

});
export default AdCreationWebsiteUrlRecord;